import {
  ArrowRight,
  Briefcase,
  Certificate,
  Check,
  CheckCircle,
  Compass,
  File,
  FileText,
  GlobeHemisphereWest,
  List,
  PencilSimple,
  ShieldCheck,
  Sparkle,
  X,
} from "@phosphor-icons/react";

const icons = {
  arrow: ArrowRight,
  briefcase: Briefcase,
  certificate: Certificate,
  check: Check,
  checkCircle: CheckCircle,
  compass: Compass,
  edit: PencilSimple,
  document: FileText,
  file: File,
  globe: GlobeHemisphereWest,
  menu: List,
  shield: ShieldCheck,
  spark: Sparkle,
  close: X,
};

export function Icon({ name, size = 20, strokeWidth = 1.8, className = "" }) {
  const Component = icons[name] || Compass;

  return (
    <Component
      aria-hidden="true"
      className={className}
      size={size}
      weight={strokeWidth >= 2 ? "bold" : "regular"}
    />
  );
}
